export default {
  installTitle: 'Install the app?',
  installDescription: 'For quick access and offline access, the SLS 24 DEV application can be installed on the device'
}